import { DashboardHeader } from '@fabric-app/business/dashboard/components/DashboardHeader';
import Skeleton from '@fabric-app/ui/components/Skeleton';
import BackButton from '../../../backNavigation/components/BackButton';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { Flex } from '@fabric-app/ui/components/Flex';
import { PathDivider } from '@fabric-app/business/resources/components/ResourcePath/ResourcePath';

type IntegrationViewProps = {
  overrideOnClose?: VoidFunction | null;
};

/**
 * Header view for Gdrive connection and ios screenshots
 * in teh future we might decouple these two as well but we will see
 */
export const FolderSkeletonHeader: React.FC<IntegrationViewProps> = (props) => {
  const { overrideOnClose } = props;
  const { isMobileView } = useResponsive();
  return (
    <DashboardHeader>
      <DashboardHeader.Body>
        <DashboardHeader.Left>
          {isMobileView ? (
            <>
              {overrideOnClose === null ? null : <BackButton onClick={overrideOnClose} />}
              <Skeleton width={240} height={30} borderRadius={30} />
            </>
          ) : (
            <Flex gap="elementsContainer" alignItems="center">
              <Skeleton width={160} height={16} borderRadius={8} />
              <PathDivider />
              <Skeleton width={120} height={16} borderRadius={8} />
            </Flex>
          )}
        </DashboardHeader.Left>
      </DashboardHeader.Body>
    </DashboardHeader>
  );
};
